import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import sliderImage from '../data/sliderImage';

const CustomSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,       
        autoplaySpeed: 3000,
        arrows: false,  
    };

    return (
        <div className="slider-container">
            <Slider {...settings}>
                {sliderImage.map((item) => (
                    <div key={item.id} className="w-[75%] slider-item flex items-center">
                        <img 
                            src={item.image} 
                            alt={`Slide ${item.id}`} 
                            className="slider-img w-[75%] outline-none"
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default CustomSlider;
